// extracted by mini-css-extract-plugin
export default {"errorMessageContainer":"ErrorMessage_errorMessageContainer__qBKs9","icon":"ErrorMessage_icon__1icto"};